const horyzenWebsite = {
  id: 4,
  slug: "horyzen-technologies",

  title: "Horyzen Technologies",

  description:
    "A modern corporate website designed to showcase Horyzen Technologies' services, portfolio, and technical expertise through a responsive, SEO-friendly, and performance-optimized user experience.",

  category: "Web Development",
  type: "Internal Project",
  status: "Completed",
  year: "2026",

  timeline: "3 Months",

  developedBy: "Horyzen Technologies",

  role: "Frontend Development",

  technologies: [
    "React",
    "JavaScript",
    "CSS3",
    "React Router",
    "GSAP",
    "HTML5"
  ],

  image: "https://images.unsplash.com/photo-1516321497487-e288fb19713f?auto=format&fit=crop&w=1600&q=80",

  liveUrl: "https://horyzen.in",
  githubUrl: "",

  featured: true
};

export default horyzenWebsite;